import React from 'react';
import { Badge } from '@mui/material';

export interface ChatUnreadBadgeProps {
  unreadCount: number;
}

/**
 * Keeps the tab's unread badge within its own layout box. MUI tabs clip
 * overflow, so positioning the badge outside the label cuts its red circle.
 */
export function ChatUnreadBadge({ unreadCount }: ChatUnreadBadgeProps) {
  if (unreadCount <= 0) return <>Chat</>;

  return (
    <Badge
      data-testid="chat-unread-badge"
      badgeContent={unreadCount}
      color="error"
      slotProps={{ badge: { style: { right: 10, zIndex: 2 } } }}
      sx={{
        pr: 2.5,
        zIndex: 1,
      }}
    >
      Chat
    </Badge>
  );
}
